import React from 'react';
import Button from './Button';

/**
 * Backward compatibility wrapper for ErrorButton.
 * Internally uses the unified modular Button component with danger variant.
 */
const ErrorButton = ({
  children,
  handleClick,
  onClick,
  disable,
  disabled,
  loading,
  type = 'button',
  size = 'base',
  className = '',
  id,
  ...rest
}) => {
  return (
    <Button
      id={id}
      type={type}
      variant="danger-outline"
      size={size}
      loading={loading}
      disabled={disable || disabled}
      onClick={handleClick || onClick}
      className={className}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ErrorButton;
